import React from 'react';
import classNames from 'classnames';
import styles from './Badge.module.scss';

interface BadgeProps {
	className?: string;
	value?: number;
}

/**
 * Generic Badge component, used for showing a number badge on components (e.g. on mini-basket)
 */
export const Badge: React.FunctionComponent<BadgeProps> = ({ className, value }) => {
	const [doAnimate, setDoAnimate] = React.useState(false);

	React.useEffect(() => {
		// Only animate when value is larger than 1
		if (!value || value < 2) {
			return;
		}
		setDoAnimate(true);

		setTimeout(() => {
			setDoAnimate(false);
		}, 500);
	}, [value]);

	return (
		<span className={classNames(styles.wrapper, className)}>
			<span
				className={classNames(styles.badge, {
					[styles.hasValue]: value && value > 0,
					[styles.doAnimate]: doAnimate,
				})}
			>
				{value}
			</span>
		</span>
	);
};
